<template>
  <div id="drawMapWrap">
    <div id="drawTools">
      <Form :model="formItem" :label-width="90">
        <FormItem label="线路名称" prop="name">
          <Input v-model="formItem.name" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="偏离时长/分">
          <p slot="label">
            <Tooltip
              content="比如5，表示偏离线路5分钟触发报警"
              placement="top-start"
              >偏离时长/分</Tooltip
            >
          </p>
          <InputNumber
            :max="90"
            :min="0"
            v-model="formItem.duration"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <FormItem label="偏离阈值/米">
          <p slot="label">
            <Tooltip
              content="比如5，表示偏离超过5米触发报警"
              placement="top-start"
              >偏离阈值/米</Tooltip
            >
          </p>
          <InputNumber
            :max="500"
            :min="0"
            v-model="formItem.distance"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <Button type="primary" :loading="loading" long @click="sumbitLine">
          <span v-if="!loading">保存线路</span>
          <span v-else>处理中...</span>
        </Button>
      </Form>
    </div>
    <div id="lineMap"></div>
    <div id="myTools">
      <p class="tabs">
        <RadioGroup v-model="drawModal">
          <Radio label="普通画线"></Radio>
          <Radio label="自动规划"></Radio>
        </RadioGroup>
      </p>
      <div v-show="drawModal == '普通画线'">
        <span
          class="iconfont icon-sousuo"
          :class="{ now: index == 1 }"
          title="搜索"
          @click="search"
        ></span>
        <span
          class="iconfont icon-edit"
          :class="{ now: index == 2 }"
          title="绘制"
          @click="fenceDraw"
          v-if="formItem.ruleRouteId == null && formItem.pointList.length == 0"
        ></span>
        <span
          class="iconfont icon-fenxi"
          :class="{ now: index == 3 }"
          title="编辑"
          @click="fenceEdit"
        ></span>
        <span
          class="iconfont icon-wancheng"
          :class="{ now: index == 4 }"
          title="完成"
          @click="fenceClose"
        ></span>
        <Tooltip placement="bottom-start" max-width="840">
          <span class="iconfont icon-tixing"></span>
          <div slot="content">
            <img src="static/line.png" width="800" />
          </div>
        </Tooltip>
        <div>
          <input
            id="searLineAeary"
            autocomplete="off"
            placeholder="请输入搜素关键词"
            v-show="searchInput"
          />
          <div id="searLineAeary123"></div>
        </div>
      </div>
      <div
        v-show="drawModal == '自动规划'"
        style="padding: 20px 10px 10px 10px"
      >
        <Form
          :label-width="60"
          ref="autoItem"
          :model="autoItem"
          :rules="ruleValidate"
        >
          <FormItem label="起点" prop="startAdd">
            <div @click="nowAdd = 1">
              <search-add @adds="reAdds"></search-add>
            </div>
          </FormItem>
          <FormItem label="终点" prop="endAdd" style="margin-top: -10px">
            <div @click="nowAdd = 2">
              <search-add @adds="reAdds"></search-add>
            </div>
            <!--  <AutoComplete
              v-model="autoItem.endAdd"
              @on-search="autoInput"
              @on-focus="autoItem.adds = []"
              clearable
              placeholder="如：广州南站"
            >
              <Option
                v-for="(item, index) in autoItem.adds"
                :value="item.district + item.name"
                :key="index"
              >
                <p @click="autoItem.end = item.location">
                  <span>{{ item.district }}</span>
                  {{ item.name }}
                </p>
              </Option>
            </AutoComplete> -->
          </FormItem>
        </Form>
        <Button @click="autoDraw('autoItem')" long>生成路线</Button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
var map, route;
var path = [
  /* [116.362209, 39.887487],
  [116.422897, 39.878002],
  [116.372105, 39.90651],
  [116.428945, 39.89663] */
];

var id;
var autopoly = [];
var mouseTool;
var polyline;
var point = [114.403322, 39.920255];
export default {
  props: ["routeData", "rightLineCenter"],
  data() {
    return {
      drawModal: "普通画线",
      center: [
        this.rightLineCenter.lng == undefined
          ? 114.403322
          : this.rightLineCenter.lng,
        this.rightLineCenter.lat == undefined
          ? 39.920255
          : this.rightLineCenter.lat,
      ],
      openCarList: false, //绑定车弹出
      searchInput: false, //地图搜索框
      loading: false, //按钮是否处于加载状态
      model2: false, //抽屉
      change: true, //抽屉
      index: "", //工具栏切换
      formItem: this.routeData,
      autoItem: {
        startAdd: "",
        endAdd: "",
        adds: [],
        start: {},
        end: {},
      },
      postPath: [],
      selectCar: [],
      ruleValidate: {
        startAdd: { required: true, message: "必填项" },
        endAdd: { required: true, message: "必填项" },
      },
      nowAdd: 1,
    };
  },
  methods: {
    //绘制基础地图
    drawMap() {
      map = new AMap.Map("lineMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 17,
      });
      mouseTool = new AMap.MouseTool(map);
      //标记中心点
      new AMap.Marker({
        map: map,
        offset: new AMap.Pixel(-25, -25),
        icon: "static/cir.png",
        position: this.center,
      });
    },
    //窗口一打开，先请求服务器数据，绘制旧围栏
    oldFence(v) {
      polyline = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: "#ffeeff",
        borderWeight: 4,
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 4,
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 50,
      });

      polyline.setMap(map);
      // 缩放地图到合适的视野级别
      map.setFitView([polyline]);
    },
    //搜索功能，定位到指定位置
    search() {
      this.index = 1;
      map.setDefaultCursor("");
      this.searchInput = !this.searchInput; //按钮显示/隐藏
      var autoOptions = {
        input: "searLineAeary",
        output: "searLineAeary123",
      };
      var auto = new AMap.Autocomplete(autoOptions);
      var placeSearch = new AMap.PlaceSearch({
        map: map,
      }); //构造地点查询类
      AMap.event.addListener(auto, "select", select); //注册监听，当选中某条记录时会触发
      function select(e) {
        path = [];
        placeSearch.setCity(e.poi.adcode);
        placeSearch.search(e.poi.name); //关键字查询查询
      }
    },
    //绘制围栏
    fenceDraw() {
      if (this.index == 3) {
        //如果是编辑状态。先帮他打勾再重绘
        this.fenceClose();
      }
      this.index = 2;
      map.setDefaultCursor("crosshair");
      mouseTool.close(true);
      this.fenceClear();
      mouseTool.polyline({
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        // strokeDasharray: [10, 5],
      });

      var that = this;

      mouseTool.on("draw", function (event) {
        map.setDefaultCursor("");
        // path = [];
        path = event.obj.getPath();
        that.oldFence();
        /* for (let i = 0; i < pathNow.length; i++) {
          var m = [pathNow[i].lng, pathNow[i].lat];
          path.push(m);
        } */
      });
    },
    //编辑围栏顶点
    fenceEdit() {
      this.index = 3;
      this.fenceClear();
      this.oldFence();
      map.setDefaultCursor("crosshair");
      if (path.length == 0) {
        return;
      }
      this._polygonEditor = new AMap.PolyEditor(
        map,
        map.getAllOverlays("polyline")[0]
      );
      //注意通过map.getAllOverlays("polygon")对象获得的是一个数组，故取数组第一个对象
      this._polygonEditor.open();
    },
    //结束绘制
    fenceClose() {
      this.index = 4;
      map.setDefaultCursor("");
      this._polygonEditor.close();
    },
    sumbitLine() {
      var pointList = this.getPoint();
      //判断是否空值
      if (pointList.length == 0 || this.formItem.name.length == 0) {
        this.$Message.error({
          content: "还没画线路或者名称未填",
          duration: 3,
        });
        return;
      }
      this.loading = true;
      if (this.formItem.ruleRouteId == null) {
        let params = {
          distance: this.formItem.distance,
          duration: this.formItem.duration,
          name: this.formItem.name,
          pointList: pointList,
          pointType: 2,
        };
        //params.append("remark", '我的线路');如：[{"x":213.123,"y":123.13},{"x":213.123,"y":123.13}]
        axios({
          method: "post",
          url: axios.serverWeb + "/ruleRoute/add",
          data: params,
        }).then((res) => {
          this.loading = false;
          if (res.data.code != 200) {
            this.$Message.error(res.data.message);
          } else {
            this.$emit("closeFence", 1);
          }
        });
      } else {
        let params = {
          ruleRouteId: this.formItem.ruleRouteId,
          distance: this.formItem.distance,
          duration: this.formItem.duration,
          name: this.formItem.name,
          pointList: pointList,
          pointType: 2,
        };

        axios({
          method: "post",
          url: axios.serverWeb + "/ruleRoute/update",
          data: params,
        }).then((res) => {
          if (res.data.code != 200) {
            this.$Message.error(res.data.message);
          } else {
            this.loading = false;
            this.$emit("closeFence", 2);
          }
        });
      }
      // console.log(path);
    },
    getPoint() {
      var myPath = [];
      if (this.drawModal == "自动规划") {
        myPath = route.getRoute();
        //myPath = route.getPoint();
      } else {
        myPath = polyline.getPath();
      }
      var arr = [];
      for (var i = 0; i < myPath.length; i++) {
        var obj = {
          x: myPath[i].lng,
          y: myPath[i].lat,
        };
        arr.push(obj);
      }
      return arr;
    },
    //清除围栏
    fenceClear() {
      var polyArr = map.getAllOverlays("polyline");
      map.remove(polyArr);
    },
    //添加车辆到围栏
    addCar() {
      this.openCarList = true;
      //执行过滤车辆。绑定的不要显示
      //this.$refs.car.fillerCar();
    },
    //点击抽屉的取消
    clickCance() {
      this.openCarList = false;
    },
    //点击抽屉的确定
    clickOk(data) {
      this.openCarList = false;
      for (let i = 0; i < data.length; i++) {
        var carObj = {
          carId: data[i].carId,
          carNo: data[i].carNo,
        };
        this.selectCar.push(carObj);
      }
    },
    //自动规划
    autoDraw(name) {
      this.fenceClear();
      this.$refs[name].validate((valid) => {
        if (valid) {
          map.clearMap();
          var path = [];
          path.push([this.autoItem.start.lng, this.autoItem.start.lat]);
          path.push([this.autoItem.end.lng, this.autoItem.end.lat]);

          map.plugin("AMap.DragRoute", function () {
            route = new AMap.DragRoute(map, path, AMap.DrivingPolicy.LEAST_FEE); //构造拖拽导航类
            route.search(); //查询导航路径并开启拖拽导航
            console.log(route.getPath());
          });
        }
      });
    },
    reAdds(v) {
      if (this.nowAdd == 1) {
        this.autoItem.startAdd = v.address;
        this.autoItem.start = {
          lng: v.gcj02x,
          lat: v.gcj02y,
        };
      } else {
        this.autoItem.endAdd = v.address;
        this.autoItem.end = {
          lng: v.gcj02x,
          lat: v.gcj02y,
        };
      }
    },
  },
  mounted() {
    this.drawMap();
    if (this.formItem.pointList.length > 0) {
      //也即是编辑或者绑定模式
      //初始化围栏
      path = [];
      var m = this.formItem.pointList;
      for (const i in m) {
        var arr = [m[i].gcj02x, m[i].gcj02y];

        path.push(arr);
      }
      this.oldFence();
    }
  },
  watch: {
    fence(val) {
      // this.formItem.input = val; //新增result的watch，监听变更并同步到myResult上
    },
  },
};
</script>
<style lang="">
/* #drawMapWrap {
  position: relative;
}
#lineMap {
  width: 100%;
  height: 400px;
  background: #f5f5f5;
}
#drawTools {
  width: 300px;
  background: #ffffff;
  border: solid 1px #999;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 20;
  padding: 20px;
}
#drawTools .ivu-form-item {
  margin-bottom: 10px;
}
#myTools {
  padding: 0px 5px;
  background: #fff;
  border: solid 1px #999;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 21;
}
#myTools span {
  margin: 0 10px;
  font-size: 26px;
  text-align: center;
  color: #999;
}
#myTools span:hover,
#myTools span.now {
  color: red;
}
#searLineAeary {
  position: absolute;
  left: 0;
  top: 40px;
  width: 100%;
  padding: 4px 10px;
}

#searLineAeary123 {
  margin-top: 30px;
  display: none;
}
#searLineAeary123 span {
  font-size: 14px !important;
  margin-left: 4px !important;
} */
</style>


// WEBPACK FOOTER //
// src/components/rule/line/smallMap.vue